import { createSignal, For } from "solid-js";
import { BaseFilter } from "./BaseFilter";

import {
  Checkbox,
  CheckboxControl,
  CheckboxLabel,
} from "@/components/shadcn/checkbox";

export const ChoiceFilter = (props) => {

  const [value, setValue] = createSignal([]);
  const [operator, setOperator] = createSignal('contains');

  const onChoiceChange = (choice, checked) => {

    if (checked && !value().includes(choice.value)) {
      setValue([...value(), choice.value]);
    }

    if (!checked && value().includes(choice.value)) {
      setValue(value().filter((v) => v !== choice.value));
    }

    props.onFilter(props.filter, operator(), value())
  }

  return (
    <BaseFilter onBack={props.onBack} onClose={props.onClose}>
      <For each={props.filter.choices}>
        {(choice) => (
          <div class="flex items-center px-1 py-2 justify-start">
            <Checkbox class="flex items-center" onChange={(checked) => onChoiceChange(choice, checked)}>
              <CheckboxControl class="border-gray-400 shadow-none me-2" />
              <CheckboxLabel class="text-xs font-medium text-muted-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                <Show when={choice.icon}>
                  <Icon icon={choice.icon} class="me-1" />
                </Show>
                {choice.text}
              </CheckboxLabel>
            </Checkbox>
          </div>
        )}
      </For>
    </BaseFilter>
  );
}
